/* tslint:disable */
/* eslint-disable */
/**
 * BFF Web Product
 * API reference used to call the backend from the web frontend
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface ChangeProductStatusRequestDto
 */
export interface ChangeProductStatusRequestDto {
    /**
     * 
     * @type {string}
     * @memberof ChangeProductStatusRequestDto
     */
    'status': ChangeProductStatusRequestDtoStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ChangeProductStatusRequestDtoStatusEnum {
    NOT_SELLING = 'notSelling',
    SELLING = 'selling',
    WAITLIST = 'waitlist'
}


